var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 34,
    viewBox: "0 0 49 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47.6721,
    height: 33,
    rx: 4.5,
    stroke: "#E5E9EC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46.6721,
    height: 32,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9678 22.4441H18.3289L19.9794 12.2393H22.6182L20.9678 22.4441Z",
    fill: "#00579F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5332 12.4882C30.0127 12.2817 29.1871 12.0537 28.1663 12.0537C25.5602 12.0537 23.7251 13.4432 23.7138 15.4298C23.6922 16.8955 25.0277 17.7096 26.0266 18.1983C27.0476 18.6977 27.3946 19.0237 27.3946 19.4688C27.3843 20.1524 26.5696 20.4676 25.8099 20.4676C24.7563 20.4676 24.1917 20.3051 23.3338 19.9248L22.9863 19.7617L22.6171 22.0525C23.236 22.3344 24.3763 22.5846 25.5602 22.5956C28.3292 22.5956 30.1319 21.2276 30.1532 19.1105C30.1638 17.9488 29.4585 17.0587 27.9381 16.3313C27.0151 15.8644 26.4499 15.5496 26.4499 15.0718C26.4607 14.6375 26.928 14.1927 27.9698 14.1927C28.8278 14.1709 29.4581 14.3771 29.9356 14.5834L30.1743 14.6918L30.5332 12.4882Z",
    fill: "#00579F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.042 18.8289C34.2593 18.2426 35.0956 15.9736 35.0956 15.9736C35.0846 15.9954 35.3125 15.3766 35.4428 14.9966L35.6272 15.876C35.6272 15.876 36.1269 18.3186 36.2355 18.8289C35.823 18.8289 34.5632 18.8289 34.042 18.8289ZM37.2994 12.2393H35.2582C34.6287 12.2393 34.1505 12.4237 33.8789 13.086L29.9591 22.4439H32.7281C32.7281 22.4439 33.1839 21.1844 33.2819 20.9131C33.5857 20.9131 36.2793 20.9131 36.6701 20.9131C36.7459 21.2714 36.985 22.4439 36.985 22.4439H39.4284L37.2994 12.2393Z",
    fill: "#00579F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1243 12.2393L13.5399 19.198L13.2575 17.7866C12.7797 16.1582 11.2812 14.3889 9.60901 13.5092L11.9762 22.4332H14.7668L18.9148 12.2393H16.1243Z",
    fill: "#00579F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1402 12.2393H6.89439L6.85095 12.4455C10.1629 13.2924 12.3564 15.3339 13.2576 17.7877L12.3346 13.0972C12.1827 12.4453 11.7157 12.2608 11.1402 12.2393Z",
    fill: "#FAA61A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.190ec74dc29806a5e2fd0221b1c4ccc7.svg";
export { ForwardRef as ReactComponent };